export default __webpack_public_path__ + "2016 Efficient photon triplet generation in integrated nanophotonic waveguides.pdf";